export default __webpack_public_path__ + "static/media/saved-icon-unfilled.a2fb217f.svg";